export default __webpack_public_path__ + "static/media/node-js.42ce8905.svg";